import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const AnouncementList = Loadable(lazy(() => import('views/announcementNewVersion/index')));
const AnouncementEdit = Loadable(lazy(() => import('views/application/announcements-new/EditAnnouncement')));
const StudentAnouncementList = Loadable(lazy(() => import('views/announcementNewVersion/index')));
const StudentAnouncementEdit = Loadable(lazy(() => import('views/application/announcements-new/staffannouncement/StaffAnnounEdit')));

const roles = ['ROLE_ADMIN', 'ROLE_COLLEGE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_COLLEGE_SUB_ADMIN'];

const AnouncementRoutes = {
    path: '/',
    element: (
        <AuthGuard roles={roles}>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/announcements',
            element: <AnouncementList />
        },
        {
            path: '/announcements/edit/:id',
            element: <AnouncementEdit />
        },
        {
            path: '/student/announcements',
            element: <StudentAnouncementList />
        },
        {
            path: '/student/announcements/edit/:id',
            element: <StudentAnouncementEdit />
        }
    ]
};
export default AnouncementRoutes;
